import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiLinux,
  SiVisualstudiocode,
  SiPostman,
  SiNetlify,
} from "react-icons/si";
import {
  FaAws,
} from "react-icons/fa";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tools-icons">
        <SiVisualstudiocode size={50}/><br/>
        <span className="purple">VS-Code</span>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiPostman size={50}/><br/>
        <span className="purple">Postman</span>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <SiNetlify size={50}/><br/>
        <span className="purple">Netlify</span>
      </Col>
      <Col xs={4} md={2} className="tools-icons">
        <FaAws size={50}/><br/>
        <span className="purple">AWS</span>
      </Col>
    </Row>
  );
}

export default Toolstack;
